export enum WaitlistStatus {
	Pending = 'pending',
	Notified = 'notified',
}
